/**
 * Mappings are typecasted with `as const` rather than using enums to
 * prevent reverse mappings generated by enums.
 */
export const AnalyticsKeys = {
	source: 'source',
} as const;

export type AnalyticsKeys = (typeof AnalyticsKeys)[keyof typeof AnalyticsKeys];

export type ExperimentLayer = {
	layerId: string | null;
	name: string;
	shadowId: string | null;
};

export const FeedbackKeys = {
	release: 'release',
	product: 'product',
	cloudId: 'cloudId',
	userId: 'userId',
	primaryProduct: 'primaryProduct',
	experimentId: 'experimentId',
	experimentLayers: 'experimentLayers',
	abTestId: 'abTestId',
	isHello: 'isHello',
	version: 'version',
} as const;

export type FeedbackKeys = (typeof FeedbackKeys)[keyof typeof FeedbackKeys];

export type FeedbackContext = {
	[AnalyticsKeys.source]?: string;
	[FeedbackKeys.abTestId]?: string;
	[FeedbackKeys.cloudId]?: string;
	[FeedbackKeys.experimentId]?: string;
	[FeedbackKeys.experimentLayers]?: ExperimentLayer[];
	[FeedbackKeys.isHello]?: boolean;
	[FeedbackKeys.primaryProduct]?: string;
	[FeedbackKeys.product]?: string;
	[FeedbackKeys.release]?: string;
	[FeedbackKeys.userId]?: string;
	[FeedbackKeys.version]?: string;
};

export const DEFAULT_GAS_CHANNEL = 'fabric-elements';
export const EVENT_SOURCE = 'advancedSearchScreen';
export const ACTION_SUBJECT_PREFIX = 'searchPage';

export enum OptionIds {
	TITLE = 'title',
	ARCHIVED = 'archived',
	ANCESTOR = 'ancestor',
	TO = 'to',
	FROM = 'from',
	LAST_MODIFIED = 'lastModified',
}

export const CURRENT = 'CURRENT';
export const ARCHIVED = 'ARCHIVED';
export const CROSSPRODUCT_SEARCH_API = 'crossProductSearch';
export const ALL_PRODUCTS_STRING = 'all';
export const ERROR_SCREEN_NAME = 'fullPageSearchErrorScreen';

export enum QueryState {
	POSTQUERY = 'PostQuery',
	PREQUERY = 'PreQuery',
}
